import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mr_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const fileUrl = (path) => (path ? `${API}/files/${path}` : null);

/**
 * Extract a safe, human-readable string from an axios error.
 * FastAPI returns 422s with `detail` as an array of objects — rendering that
 * directly in React (`<p>{detail}</p>` or in toast) crashes the app.
 */
export const apiErrorMessage = (err, fallback = "Something went wrong") => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => (typeof d === "string" ? d : (d?.msg || d?.message || ""))).filter(Boolean).join(", ") || fallback;
  }
  if (detail && typeof detail === "object") return detail.msg || detail.message || fallback;
  return err?.message || fallback;
};

export default api;
